export default "__VITE_ASSET__833d75e5__"